import React from "react";

const ShowError = ({ children = "Something went wrong..." }) => (
  <div style={{ color: "crimson" }}>{children}</div>
);

export default ShowError;



// WEBPACK FOOTER //
// ./src/features/insights/show-error.js